<template lang="">
<div class="weddingCard_wrap">
    <div class="weddingCard">
        <div class="section section_1 type1">
            <h5 class="tit">
                Wedding Day
            </h5>
            <p class="sub">
                We would be grateful if you could join us on <br>
                our wedding day and bless the start of our new life together.
            </p>
            <div class="date">{{ changeDateString(weddingInfo.eventDate) }} {{ getDayName(weddingInfo.eventDate) }}</div>
            <div class="img_wrap">
                <img :src="$getImgUrl(weddingInfo.mainImgPath)" alt="">
            </div>
            <div class="name_wrap">
                <p class="groom">{{ weddingInfo.groomName }}</p>
                <p class="bride">{{ weddingInfo.brideName }}</p>
            </div>
            <div class="detail">
                {{ $localizeDate(weddingInfo.eventDate, true) }} {{ $getDayName(weddingInfo.eventDate, true) }} {{ weddingInfo.eventTime }} <br>
                {{ weddingInfo.eventLocationName }} {{ weddingInfo.eventLocationDetail }}
            </div>
        </div>
        <div class="section section_2 type1">
            <div class="top">
                <div class="img">
                    <img src="../../../assets/images/common/ico_edit_02.png" alt="">
                </div>
                <!-- <h5 class="main_msg">우리<br> 결혼합니다</h5>
                <span class="main_eng">Join us for the wedding</span>
                <p class="sub_msg">
                    두 사람이 사랑으로 만나 <br>
                    진실과 이해로써 하나를 이루려 합니다. <br>
                    여러 어른과 친지분들을 모시고 서약을 맺고자 하오니 <br>
                    바쁘신 가운데 두 사람의 장래를 <br>
                    가까이에서 축복해 주시면 고맙겠습니다.
                </p> -->
                <h5 class="main_msg">{{ weddingInfo.mainMessage }}</h5>
                <!-- <span class="main_eng">Join us for the wedding</span> -->
                <p class="sub_msg" v-html="weddingInfo.greetingsMessage">
                </p>
            </div>
            <div class="bottom">
                <p>Our Family</p>
                <ul>
                    <li><span>신랑 부</span> {{ weddingInfo.groomFatherName }}</li>
                    <li><span>신부 부</span> {{ weddingInfo.brideFatherName }}</li>
                    <li><span>신랑 모</span> {{ weddingInfo.groomMotherName }}</li>
                    <li><span>신부 모</span> {{ weddingInfo.brideMotherName }}</li>
                    <li><span>신랑</span> {{ weddingInfo.groomName }}</li>
                    <li><span>신부</span> {{ weddingInfo.brideName }}</li>
                </ul>
            </div>
        </div>
        <div class="section section_3 type1">
            <div class="tit">Wedding Gallery</div>
            <div class="img_wrap">
                <div class="preview">
                    <img :src="$getImgUrl(weddingInfo.attachList[selectedThumbnailIdx])" alt="">
                    <div class="preview_btn">
                        <a @click="changeMainThumbnail('prev')" class="btn_prevImg"></a>
                        <a @click="changeMainThumbnail('next')" class="btn_nextImg"></a>
                    </div>
                </div>
                <ul class="thumb">
                    <li v-for="(attach, index) in weddingInfo.attachList" @click="selectThumbnail(index)"><img :src="$getImgUrl(attach)" alt="" style="width: 100%"></li>
                </ul>
            </div>
        </div>
        <div class="section section_4 type1">
            <div class="tit">
                안내 사항
            </div>
            <p class="txt mt15 padding030">
                {{ weddingInfo.noticeMessage }}
            </p>
        </div>
        <div class="section section_5 type1">
            <div class="tit">
                {{ weddingInfo.thankYouMessage }}
            </div>
            <p class="txt">
                축하의 마음을 담아 축의금을 전달해보세요.
            </p>
            <ul>
                <li v-for="congratInfo in weddingInfo.congratInfoList">
                    <span v-if="congratInfo.weddingSide === 'groom'">신랑측</span><span v-else>신부측</span> <b>{{ congratInfo.name }}</b> ({{ congratInfo.bankName }} {{ congratInfo.bankNumber }})
                </li>
            </ul>
        </div>
        <div class="section section_6 type1" v-if="weddingInfo.campaign.campaignSeq">
            <div class="tit">
                디지털 기부 화환
            </div>
            <p class="txt">
                디지털 기부 화환은 축하 화환을 디지털 화환으로 <br>
                제공 되는 서비스입니다. <br>
                디지털 화환의 결제 금액의 일부는 다양한 <br>
                사회적 활동에 기부가 됩니다.
            </p>
            <div class="box">
                <div class="img_wrap">
                    <img :src="$getImgUrl(campaignThumbnail)" alt="">
                </div>
                <div class="txt_wrap">
                    <h5>[후원캠페인]</h5>
                    <p>
                        {{ weddingInfo.campaign.campaignName }}
                    </p>
                    <div>기본 운영비 <span>{{ $addComma(weddingInfo.campaign.campaignAmount) }}원</span></div>
                </div>
            </div>
            <div class="btn_wrap">
                <a href="" class="btn_view">미리보기</a>
                <a class="btn_support" @click="makePayment">후원하기</a>
            </div>
        </div>
        <div class="section section_7 type1">
            <div class="tit">
                오시는 길
            </div>
            <p class="txt">
                {{ weddingInfo.mapAddress }} <br>
                {{ weddingInfo.eventLocationName }}
            </p>
            <div class="map_wrap">
                <div id="map">
                    지도
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    props: {
        weddingInfo: {
            type: Object,
            required: true
        },
        invitationSeq: {
            type: String
        }
    },

    data () {
        return {
            selectedThumbnailIdx: 0,
            map: null,
            marker: null,
            infoWindow: null,
            mapInitTimer: null
        }
    },

    methods: {
        selectThumbnail (i) {
            this.selectedThumbnailIdx = i;
        },

        changeMainThumbnail (direction) {
            const attachList = Array.isArray(this.weddingInfo.attachList)
                ? this.weddingInfo.attachList
                : [];

            if (attachList.length === 0) return;

            if (direction == 'prev' && this.selectedThumbnailIdx != 0) {
                this.selectedThumbnailIdx -= 1
            } else if (direction == 'next' && this.selectedThumbnailIdx != this.weddingInfo.attachList.length - 1){
                this.selectedThumbnailIdx += 1
            }
        },

        changeDateString(dateString) {
            return dateString.substring(0, 4) + '. ' + dateString.substring(5, 7) + '. ' + dateString.substring(8, 10)
        },

        getDayName(dateString) {
            const days = ['SUN', 'MON', 'TUE', 'WED', 'THUR', 'FRI', 'SAT', 'SUN']
            const date = new Date(dateString)
            return days[date.getDay()]
        },

        makePayment () {
            const paymentAmount = this.weddingInfo.campaign.campaignAmount
            const campaignName = this.weddingInfo.campaign.campaignName
            const invitationSeq = this.invitationSeq
            this.$openModal('paymentModal', {
                paymentAmount: paymentAmount,
                campaignName: campaignName,
                invitationSeq: invitationSeq,
                invitationType: 'W'
            })
        },

        initMap (latitude, longitude, name) {
            console.log('=== [initMap 호출] ===');
            console.log('[initMap] raw latitude:', latitude, typeof latitude);
            console.log('[initMap] raw longitude:', longitude, typeof longitude);
            console.log('[initMap] raw name:', name);

            const container = document.getElementById('map');
            console.log('[initMap] container:', container);

            if (!container) {
                console.error('map element not found');
                return;
            }

            console.log('[initMap] kakao:', typeof kakao);
            console.log('[initMap] kakao.maps:', typeof kakao !== 'undefined' ? kakao.maps : undefined);

            if (typeof kakao === 'undefined' || !kakao.maps) {
                console.error('kakao maps not loaded');
                return;
            }

            if (latitude == null || longitude == null) {
                console.error('invalid map coordinates', { latitude, longitude });
                return;
            }

            const lat = Number(latitude);
            const lng = Number(longitude);

            console.log('[initMap] parsed lat/lng:', lat, lng);

            if (Number.isNaN(lat) || Number.isNaN(lng)) {
                console.error('coordinates are not numbers', { latitude, longitude });
                return;
            }

            var options = {
                center: new kakao.maps.LatLng(lat, lng),
                level: 4,
                draggable: false
            };

            console.log('[initMap] options:', options);


            this.map = new kakao.maps.Map(container, options);
            console.log('[initMap] map created:', this.map);

            this.marker = new kakao.maps.Marker({
                position: options.center,
                map: this.map,
            });
             console.log('[initMap] marker created:', this.marker);


            if (name) {
                this.infoWindow = new kakao.maps.InfoWindow({
                    content: `<div style="padding:5px;font-size:14px;">${name}</div>`,
                });
                this.infoWindow.open(this.map, this.marker);
                console.log('[initMap] infoWindow opened');
            }
        }
    },

    mounted () {

        console.log('=== [mounted 시작] ===');

        console.log('[mounted] weddingInfo:', this.weddingInfo);
        console.log('[mounted] lat/lng:', 
            this.weddingInfo?.eventLatitude, 
            this.weddingInfo?.eventLongitude
        );

        
        console.log('[mounted] kakao:', typeof kakao);

        this.$nextTick(() => {
            console.log('=== [nextTick 진입] ===');

            

            setTimeout(() => {
                console.log('=== [setTimeout 진입] ===');

                
                console.log('[setTimeout] kakao:', typeof kakao);

                this.initMap(
                    this.weddingInfo.eventLatitude,
                    this.weddingInfo.eventLongitude,
                    this.weddingInfo.eventLocationName
                );
            }, 200);
        });        


        console.log('weddingInfo:', this.weddingInfo);
        console.log('attachList:', this.weddingInfo.attachList);
    },

    beforeUnmount() {
        if (this.mapInitTimer) {
            clearTimeout(this.mapInitTimer);
            this.mapInitTimer = null;
        }
    },

    computed: {
        campaignThumbnail() {
            return this.weddingInfo?.campaign?.campaignThumbnailPath || '';
        }
    }
}
</script>
<style lang="">

</style>